import Vue from 'vue'
import QR from './QR.vue'
const QRCreater = Vue.extend(QR)
let qRInstance

export default {
  open (closeEvent) {
    if (!qRInstance) {
      qRInstance = new QRCreater({
        el: document.createElement('div'),
      })
      document.body.appendChild(qRInstance.$el)
    }
    qRInstance.visible = true
    qRInstance.closeEvent = closeEvent
    qRInstance.init()
  }
}